import styled from "styled-components";
import { Stepper as MaterialStepper } from "@material-ui/core";

export const Stepper = styled(MaterialStepper)`
    & .MuiStepContent-root,
    .MuiStepConnector-vertical {
        margin-left: 10px;
    }
`;

export const AltStepper = styled(MaterialStepper)`
    padding: ${({ theme }) => theme.spacing(1)}px;
    background-color: transparent;

    & .MuiStepContent-root,
    .MuiStepConnector-vertical {
        margin-left: 5px;
    }

    .MuiStepIcon-active {
        width: 0.5em;
        height: 0.5em;
    }

    .MuiStepConnector-active {
        padding-bottom: 0;
    }

    .MuiStepContent-root {
        margin-top: 0;
        padding-left: 12px;
        padding-right: 0;
    }
`;
